import { combineReducers } from 'redux';
import { Map } from 'immutable';
import { createStructuredSelector } from 'reselect';

import {
	COUPONS_CREATE,
	COUPONS_CREATE_SUCCESS,
	COUPONS_CREATE_FAIL,
	COUPONS_UPDATE,
	COUPONS_UPDATE_SUCCESS,
	COUPONS_UPDATE_FAIL,
	COUPONS_RESET,
	COUPONS_RESET_SUCCESS,
	COUPONS_RESET_FAIL,
	COUPONS_COPY,
	COUPONS_COPY_SUCCESS,
	COUPONS_COPY_FAIL,
	COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS,
	COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS,
	COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL,
	COUPONS_GET_DETAILS,
	COUPONS_GET_DETAILS_SUCCESS,
	COUPONS_GET_DETAILS_FAIL,
	COUPONS_GET_OPTIONS,
	COUPONS_GET_OPTIONS_SUCCESS,
	COUPONS_GET_OPTIONS_FAIL,
} from 'Constants/actionTypes';

const statusReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COUPONS_CREATE:
		return state.set('coupon', 'creating');
	case COUPONS_UPDATE:
		return state.set('coupon', 'submitting');
	case COUPONS_RESET:
		return state.set('coupon', 'resetting');
	case COUPONS_COPY:
		return state.set('coupon', 'copying');
	case COUPONS_CREATE_SUCCESS:
		return state.set('coupon', 'created');
	case COUPONS_UPDATE_SUCCESS:
		return state.set('coupon', 'submitted');
	case COUPONS_RESET_SUCCESS:
		return state.set('coupon', 'reset');
	case COUPONS_COPY_SUCCESS:
		return state.set('coupon', 'copied');
	case COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return state.set('coupons', 'fetching');
	case COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS:
		return state.set('coupons', 'fetched');
	case COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL:
		return state.set('coupons', 'has-errors');
	case COUPONS_GET_DETAILS:
		return state.set('coupon', 'fetching');
	case COUPONS_GET_DETAILS_SUCCESS:
		return state.set('coupon', 'fetched');
	case COUPONS_CREATE_FAIL:
	case COUPONS_UPDATE_FAIL:
	case COUPONS_RESET_FAIL:
	case COUPONS_COPY_FAIL:
	case COUPONS_GET_DETAILS_FAIL:
		return state.set('coupon', 'has-errors');
	case COUPONS_GET_OPTIONS:
		return state.set('options', 'fetching');
	case COUPONS_GET_OPTIONS_SUCCESS:
		return state.set('options', 'fetched');
	case COUPONS_GET_OPTIONS_FAIL:
		return state.set('options', 'has-errors');
	default:
		return state;
	}
};

const currentReducer = (state = null, action) => {
	switch (action.type) {
	case COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return null;
	case COUPONS_CREATE_SUCCESS:
	case COUPONS_UPDATE_SUCCESS:
	case COUPONS_RESET_SUCCESS:
	case COUPONS_GET_DETAILS_SUCCESS:
		return action.payload.br_no;
	case COUPONS_COPY_SUCCESS:
		return action.payload && action.payload.br_no ? action.payload.br_no : state;
	default:
		return state;
	}
};

const couponsByPageReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return state;
	case COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS:
		return new Map(action.payload);
	default:
		return state;
	}
};

const couponReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COUPONS_CREATE:
		return state;
	case COUPONS_GET_DETAILS:
		return new Map();
	case COUPONS_CREATE_SUCCESS:
	case COUPONS_UPDATE_SUCCESS:
	case COUPONS_RESET_SUCCESS:
	case COUPONS_GET_DETAILS_SUCCESS:
		return state.set(action.payload.br_no, action.payload);
	case COUPONS_COPY_SUCCESS:
		if (action.payload && action.payload.br_no) {
			return state.set(action.payload.br_no, action.payload);
		}
		return state;
	default:
		return state;
	}
};

const copyResultReducer = (state = null, action) => {
	switch (action.type) {
	case COUPONS_COPY:
	case COUPONS_COPY_FAIL:
		return null;
	case COUPONS_COPY_SUCCESS:
		return action.payload;
	default:
		return state;
	}
};

const optionsReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COUPONS_GET_OPTIONS:
		return new Map();
	case COUPONS_GET_OPTIONS_SUCCESS:
		return new Map(action.payload);
	default:
		return state;
	}
};

export default combineReducers({
	status: statusReducer,
	current: currentReducer,
	copyResult: copyResultReducer,
	couponsByPage: couponsByPageReducer,
	coupon: couponReducer,
	options: optionsReducer,
});

export const selector = createStructuredSelector({
	status: (state) => state.coupons.status,
	current: (state) => state.coupons.current,
	copyResult: (state) => state.coupons.copyResult,
	couponsByPage: (state) => state.coupons.couponsByPage,
	coupon: (state) => state.coupons.coupon,
	options: (state) => state.coupons.options,
	errors: (state) => state.errors.get('coupon'),
});
